var exports = {
  "Y": "x43aef4ae--ce9102--price-range-inputs",
  "n": "x43aef4ae--ce9102--row",
};

module.exports = exports;
